import React, { useEffect, useState } from 'react';
import '../../assets/styles/component/feedback/toast.css';
import Icon from '../ui/icon';

const Toast = ({ toastInfo, onClose }) => {
    const [visible, setVisible] = useState(true);
    const [fadeOut, setfadeOut] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
            setTimeout(onClose, 500);
        }, 3500);
        setTimeout(() => {
            setfadeOut(true);
        }, 3000);
        return () => clearTimeout(timer);
    }, [onClose]);

    if (!visible) return null;

    return (
        <div className="toast-container">
            <div className={`toast ${toastInfo.status} ${fadeOut ? 'fadeOut' : ''}`}>
                {toastInfo.status === 'success' ? (
                    <Icon name="CheckCircle" />
                ) : toastInfo.status === 'error' ? (
                    <Icon name="ExclamationCircle" />
                ) : <Icon name="CheckCircle" />}
                {toastInfo.message}
            </div>
        </div>
    );
};

export default Toast;